import { useState } from 'react';
import { Table } from '../../../../components/general/table';
import { useFunctionariesSwitchHistorical } from './hook';
import { FunctionariesSwitchHistoricalProps } from './props';

export const FunctionariesSwitchHistorical = ({
    historical,
    showHistorical,
}: FunctionariesSwitchHistoricalProps) => {
    const { columns, rows } = useFunctionariesSwitchHistorical({
        historical,
        showHistorical,
    });

    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });

    const handlePaginationChange = (newPagination: {
        page: number;
        pageSize: number;
    }) => {
        setPaginationModel(newPagination);
    };

    if (!showHistorical) return null;

    const paginatedRows = rows.slice(
        paginationModel.page * paginationModel.pageSize,
        (paginationModel.page + 1) * paginationModel.pageSize
    );

    return (
        <Table
            columns={columns}
            rows={paginatedRows}
            rowCount={rows.length}
            paginationModel={paginationModel}
            onPaginationModelChange={handlePaginationChange}
            pageSizeOptions={[10, 20, 50]}
            disableRowSelectionOnClick
        />
    );
};
